/*
 App

 Definicja aplikacji 
 Ekran główny  - zobacz
 // https://material-ui.com/getting-started/page-layout-examples/

 Dla testów:
    - testy komponentów: w miejsce <Booking /> wstaw  <ComponentTest />
 Todo:
  - nie skończone logowanie / wylogowywanie
  
 historia: 
  04-2019 JW - start
*/

import { Fab, Grid, Paper, Typography } from '@material-ui/core';
import { MuiThemeProvider, Theme, withStyles, WithStyles } from '@material-ui/core/styles';
import * as React from 'react';
import { connect } from 'react-redux';
import { Info, Oauth2Service, obiektService, RodzPokoiInfo, roomsService } from './api';

// import Booking from './app/Booking';
// import CenterPanel from './app/centerPanel/CenterPanel';
// import CenterRight from './app/centerPanel/CenterRight';
// import CookiesFooter from './app/common/CookiesFooter';
// import DialogError from './app/common/DialogError';
// import { daysFromDate, sendErrorLog, themeExist, themeSelect } from './app/common/helpers';
// import OknoPrzerwa from './app/common/OknoPrzerwa';
// import MapContainer from './app/map/MapContainer';
// import PanelRight from './app/PanelRight';
// import Failure from './app/payment/Failure';
// import Success from './app/payment/Success';

import { Actions, AppState, store, IPageState, DisplayState } from './appredux';
import CONFIG, { window2config } from './cfg/config';
import { fontSelect } from './fonts';
import theme from './themes';
import themeBlue from './themesBlue';
import themeBrownDark from './themesBrownDark';
import themeBrownLight from './themesBrownLight';
import themeGreen from './themesGreen';
import Main from './pages/Main';
import DialogError from 'components/DialogError';



//PM 2021-10-29
//wstrzykniecie tylko uzywanych pol z magazynu danych
interface AppProps {
  page: IPageState
}

//PM 2021-10-29
//cookiesZaakceptowane: boolean
interface AppStateInterface {


}

let selectedTheme: Theme;

class App extends React.Component<AppProps & WithStyles<typeof styles>, AppStateInterface> {

  //PM 2021-10-29
  //(props: AppProps & WithStyles<typeof styles>)
  //cookiesZaakceptowane: cookiesZaakceptowane ? true : false
  constructor(props: AppProps & WithStyles<typeof styles>) {
    super(props, {});
    window2config();
    //const cookiesZaakceptowane = localStorage.getItem('cookies_zaakceptowane')

    this.state = {
      //windowWidth: window.innerWidth,

      //cookiesZaakceptowane: cookiesZaakceptowane ? true : false
    }

    // const title = document.getElementsByTagName("title")[0];

    // let text = CONFIG.hotelID.split(" ").map((current: string) => current.charAt(0).toUpperCase() + current.slice(1).toLowerCase()).join(" ")
    // text = text.split("-").map((current: string) => current.charAt(0).toUpperCase() + current.slice(1)).join("-")

    // title.innerText = "Rezerwacje " + text

    // window.onbeforeunload = function () {
    //   sendErrorLog("1", "1", 'zamknięcie aplikacji')

    // };

    let openKodyBledow = localStorage.getItem("openKodyBledow");

    if(openKodyBledow){
      store.dispatch(Actions.pageState.setDisplayState(DisplayState.kodyBledow, true));
      localStorage.removeItem("openKodyBledow")
    }

  }




  render() {
    const { classes } = this.props;
    //const tloUrl: string = `${CONFIG.apiURL}/hotel/image/${CONFIG.hotelID}/tlo.png`;
    //const logoUrl: string = `${CONFIG.apiURL}/hotel/image/${CONFIG.hotelID}/startowe.jpg` || '';
    
    // if (this.state.info.materialuiZestawNr === "1")
    //   selectedTheme = theme;
    // else if (this.state.info.materialuiZestawNr === "2")
    //   selectedTheme = themeBlue;
    // else if (this.state.info.materialuiZestawNr === "3")
    //   selectedTheme = themeBrownDark;
    // else if (this.state.info.materialuiZestawNr === "4")
    //   selectedTheme = themeBrownLight;
    // else
      selectedTheme = theme;

    //selectedTheme = themeBrownLight;

    let textTheme = fontSelect(3, 2) as React.CSSProperties;
    let color = ""
    if (textTheme && Object.keys(textTheme).length !== 0) {
      color = textTheme.color as string
    }

    return (
      <React.Fragment>
        <div className={classes.root} style={{  }}> {/*  background: `url(${tloUrl})`, */}
          <MuiThemeProvider theme={selectedTheme}>
            <Main/>

            <div id="dialog"></div>
            <div id="dialog2"></div>

            <DialogError/>
          </MuiThemeProvider>
        </div>
      </React.Fragment>
    );
  }
}

const styles = (theme: Theme) => ({
  root: {
    padding: "5px",
    //minHeight: "98vh",
    //background: `url(${tloUrl})`,
    fontSize: "12px",
    fontFamily: "\"Arial\", \"Helvetica\", sans-serif",
    lineHeight: "20px",
    fontWeight: theme.typography.body2.fontWeight
  }
});

const mapStateToProps = (state: AppState) => ({
  page: state.pageState,

});

export default connect(mapStateToProps)(withStyles(styles)(App));
